module.exports = __webpack_public_path__ + "media/newstyle/images/logo-clube-de-autores-59522bcea888bc7b174704bac8b15577.svg";